export default __webpack_public_path__ + "static/media/fondo-clientes-3.bfb4e423.png";